var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpectedDeliveryDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0106 3.8026V26.2063H43.2083V15.0044H3.97693V40.2086H23.5926V43.009H1.17468V3.8026H9.58142V1.00214H12.3837V3.8026H34.8016V1.00214H37.6039V3.8026H46.0106ZM43.2083 12.204V6.60306H37.6039V9.40352H34.8016V6.60306H12.3837V9.40352H9.58142V6.60306H3.97693V12.204H43.2083ZM43.6243 30.8227L45.5946 32.7917L33.4005 45L27.5114 39.0928L29.4817 37.1237L33.4005 41.0181L43.6243 30.8227Z",
    fill: "#9B9B9B",
    stroke: "#9B9B9B",
    strokeWidth: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectedDeliveryDate);
export default __webpack_public_path__ + "static/media/expected-delivery-date.f5203d40a951ca3473dadc878fde8bdb.svg";
export { ForwardRef as ReactComponent };